module.exports = __webpack_public_path__ + "static/media/domain6.6a07a520.png";